import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const OrderedListIcon = (props: IconProps) => (
  <Icon width="20px" height="20px" viewBox="0 0 20 20" {...props}>
    <path d="M1.66663 14.1666H3.33329V14.5833H2.49996V15.4166H3.33329V15.8333H1.66663V16.6666H4.16663V13.3333H1.66663V14.1666ZM2.49996 6.66659H3.33329V3.33325H1.66663V4.16659H2.49996V6.66659ZM1.66663 9.16658H3.16663L1.66663 10.9166V11.6666H4.16663V10.8333H2.66663L4.16663 9.08325V8.33325H1.66663V9.16658ZM5.83329 4.16659V5.83325H17.5V4.16659H5.83329ZM5.83329 15.8333H17.5V14.1666H5.83329V15.8333ZM5.83329 10.8333H17.5V9.16658H5.83329V10.8333Z" />
  </Icon>
);

export default memo(OrderedListIcon);
